import { Component, Event, EventEmitter, h, Prop, Element } from '@stencil/core';
import { SelectOption } from '../../../types/types';
import { ClickOutside } from '../../../utils/stencil/clickOutside';

@Component({
  tag: 'rentware-expanded-picker',
  styleUrl: 'style.sass',
  shadow: true,
})
export class rentwareExpandedPicker {
  @Prop() options: SelectOption[];
  @Prop() autoClose: boolean;
  @Prop() onSelectTime: (hour: string) => void;

  @Event() clickOutsideCalendarTime: EventEmitter;
  @Event() clickOutsideCalendar: EventEmitter;
  @Event() clickOutsideRangeCalendar: EventEmitter;

  @Element() expandedPickerElement: HTMLElement;

  @ClickOutside()
  handleOutside() {
    this.clickOutsideCalendarTime.emit();
  }

  onClickHandler = (hour: string) => {
    this.onSelectTime(hour);
    if (this.autoClose) {
      this.clickOutsideCalendar.emit();
      this.clickOutsideRangeCalendar.emit();
    }
  };

  render() {
    return (
      <div class="ExpandedInner">
        {this.options?.map(option => {
          return (
            <p class="Item" onClick={() => this.onClickHandler(option.value)}>
              {option.label}
            </p>
          );
        })}
      </div>
    );
  }
}
